import Service from '../Service'

export default class PlanoContaContabilService extends Service{

    constructor(){
        super('planocontacontabil');
    }

  }